import { useEffect, useState, useContext } from 'react';
import { Box, Grid, FormControl } from '@mui/material';
import { FormikProps, useFormikContext } from 'formik';
import { FieldType } from '../../types';
import { CommonDataContext } from '../../../context';
import { DefaultCheckboxText } from './DefaultCheckboxText';
import { CustomCheckboxText } from './CustomCheckboxText';
import _ from 'lodash';

export const TermsAndConditionsField = ({
  itemData,
  value,
  locale,
  externalData,
}: {
  itemData: FieldType;
  value: any;
  locale: string;
  externalData: any
}) => {

  const formik: FormikProps<any> = useFormikContext();
  const { highlightErrorFieldsState } = useContext(CommonDataContext);

  const [isInvalid, setIsInvalid] = useState(false);


  const handleAccept = () => {
    const newValue = !value;
    formik.setFieldValue(itemData.config.fieldName, newValue);
    formik.setFieldError(itemData.config.fieldName, !newValue ? 'required' : '');
    setIsInvalid(!newValue);
  };


  useEffect(() => {
    // if (value) {
    //   setIsInvalid(false/* evaluateIfInvalid(value) */);
    // }
    return () => {
      formik.setFieldError(itemData.config.fieldName, '');
    };
  }, []);

  useEffect(() => {
    if (highlightErrorFieldsState.state) {
      setIsInvalid(!!formik.getFieldMeta(itemData.config.fieldName).error);
    }
  }, [highlightErrorFieldsState]);


  useEffect(() => {
    if (itemData.config.displayed) {
      let isEmpty = false;
      if (itemData.config.required) {
        isEmpty = !value;
      }
      formik.setFieldError(
        itemData.config.fieldName,
        isInvalid || isEmpty ? 'required' : ''
      );
    }
  }, [itemData.config.displayed, itemData.config.required, isInvalid, value]);

  if (!itemData.config.displayed) {
    return null;
  }

  return (
    <Box
      component={Grid}
      item
      xs={12}
    >
      <FormControl required error={isInvalid}>
        {itemData.config.useDefaultCheckboxText
          ? <DefaultCheckboxText
            locale={locale}
            value={value}
            itemData={itemData}
            isInvalid={isInvalid}
            externalData={externalData}
            handleAccept={handleAccept}
          />
          : <CustomCheckboxText
            value={value}
            itemData={itemData}
            isInvalid={isInvalid}
            handleAccept={handleAccept}
          />
        }
      </FormControl>
    </Box>
  );
};
